import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgDrivingLicense = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.009 5h11.983c.55 0 1.007 0 1.38.03.39.032.753.1 1.096.276.527.269.957.698 1.226 1.226.194.38.258.787.285 1.228.021.345.021.762.021 1.254v5.814c0 .548 0 1.005-.03 1.378-.032.389-.1.752-.276 1.096-.269.528-.698.957-1.226 1.226-.343.174-.707.243-1.096.275-.373.03-.83.03-1.38.03H6.008c-.55 0-1.008 0-1.381-.03-.39-.032-.753-.1-1.096-.276a2.8 2.8 0 0 1-1.226-1.226c-.175-.343-.244-.706-.276-1.095C2 15.832 2 15.375 2 14.825V9.016c0-.51 0-.92.019-1.253.026-.46.091-.847.287-1.231a2.8 2.8 0 0 1 1.226-1.226c.343-.175.707-.244 1.096-.276C5 5 5.458 5 6.008 5m-1.26 1.526c-.296.024-.44.067-.536.116-.191.097-.354.24-.476.414h16.526a1.3 1.3 0 0 0-.476-.414c-.097-.049-.24-.092-.537-.116-.305-.025-.7-.026-1.289-.026H6.04c-.588 0-.984 0-1.29.026m15.75 2.03H3.501l-.001.483v5.755c0 .588 0 .984.026 1.29.024.296.067.44.116.537.126.245.325.445.57.57.097.05.241.093.538.117.305.025.701.025 1.29.025H17.96c.588 0 .984 0 1.29-.025.295-.024.44-.068.536-.117.246-.125.446-.325.57-.57.05-.097.093-.241.118-.537.024-.306.025-.701.025-1.29V8.556m-4.045 2.398a1.306 1.306 0 1 0 0 2.61 1.306 1.306 0 0 0 0-2.61m-2.806 1.305a2.806 2.806 0 1 1 5.611 0 2.806 2.806 0 0 1-5.61 0m-9.25-1.37a.75.75 0 0 1 .75-.75h3.083a.75.75 0 0 1 0 1.5H5.148a.75.75 0 0 1-.75-.75m0 3.083a.75.75 0 0 1 .75-.75H9.26a.75.75 0 0 1 0 1.5H5.15a.75.75 0 0 1-.75-.75"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgDrivingLicense;
